import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const SecForward: React.FC<CustomIconProps> = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.0669 7.70391H6.89489L9.43089 10.2399L8.0169 11.6539L3.06689 6.70391L8.0169 1.75391L9.43089 3.16791L6.89489 5.70391H14.0669C16.1886 5.70391 18.2235 6.54676 19.7237 8.04705C21.224 9.54734 22.0669 11.5822 22.0669 13.7039C22.0669 15.8256 21.224 17.8605 19.7237 19.3608C18.2235 20.8611 16.1886 21.7039 14.0669 21.7039H13.0669V19.7039H14.0669C15.6582 19.7039 17.1843 19.0718 18.3095 17.9465C19.4348 16.8213 20.0669 15.2952 20.0669 13.7039C20.0669 12.1126 19.4348 10.5865 18.3095 9.46127C17.1843 8.33605 15.6582 7.70391 14.0669 7.70391ZM7.01697 21.6151C7.53543 21.7519 8.05748 21.8203 8.58313 21.8203C9.3032 21.8203 9.89366 21.7051 10.3545 21.4747C10.8226 21.2371 11.1682 20.931 11.3914 20.5566C11.6146 20.1749 11.7262 19.7609 11.7262 19.3145C11.7262 18.868 11.6218 18.4684 11.413 18.1155C11.2042 17.7627 10.8694 17.4855 10.4085 17.2839C9.95487 17.075 9.35361 16.9706 8.60473 16.9706H7.98457L8.11238 15.5341H11.2618V14.1299H6.64974L6.2609 18.3856H8.19429C8.65514 18.3856 9.01157 18.4252 9.2636 18.5044C9.52283 18.5836 9.70284 18.6988 9.80365 18.85C9.90446 19.0012 9.95487 19.174 9.95487 19.3685C9.95487 19.6781 9.82886 19.9193 9.57683 20.0921C9.3248 20.265 8.97917 20.3514 8.53993 20.3514C8.15109 20.3514 7.76585 20.2902 7.38421 20.1677C7.00977 20.0453 6.67854 19.8797 6.39051 19.6709L5.69924 21.0102C6.06648 21.2695 6.50572 21.4711 7.01697 21.6151ZM2.94927 15.5341V21.6907H4.69904V14.1299H1.43711V15.5341H2.94927Z'
      fill='white'
    />
  </svg>
);

export default SecForward;
